import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_LOGS_COUNT } from "../types";
import {
  getLogsCountPending,
  getLogsCountFulfilled,
  getLogsCountRejected,
  setNoEntriesMessageLogs,
} from "../actions";
import { sendApiRequest, notifyError } from "../../../actions";
import generateError from "../../../utilities/generateError";
import { LOG_MESSAGES } from "../constants/logMessages";

const createPayload = (payload) => ({
  method: "get",
  url: "log/count",
  onSuccess: [
    (response) =>
      response.data === 0
        ? setNoEntriesMessageLogs(LOG_MESSAGES.NOT_FOUND)
        : setNoEntriesMessageLogs(""),

    (response) => getLogsCountFulfilled(response),
  ],
  onError: [getLogsCountRejected, (error) => notifyError(generateError(error))],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getLogsCountEpic$ = (action$) =>
  action$.pipe(
    ofType(GET_LOGS_COUNT.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) =>
      merge(
        of(getLogsCountPending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default getLogsCountEpic$;



// WEBPACK FOOTER //
// ./src/features/log/epics/getLogsCountEpic.js